const VISIBLE_EDGE = 4;

export function maskAccessKey(key: string): string {
  if (key.length <= VISIBLE_EDGE * 2) return key;
  return `${key.slice(0, VISIBLE_EDGE)}••••${key.slice(-VISIBLE_EDGE)}`;
}
